export const Routes = {
  Home: '/',
  Register: '/auth/register',
  CheckEmail: '/check-email',
  CreateAmp: '/create-amp',
  EmailSent: '/email-sent',

  Dashboard: '/dashboard',

  LiveAmps: '/dashboard/live-amps',
  FavoriteAmps: '/dashboard/favorites',
  Search: '/dashboard/search',

  AmpBuilder: (id) => `/builder/${id}`,
  AmpInsights: (id) => `/amp/${id}/insights`,
  AmpReviewDocument: (id) => `/review-document/${id}`,

  Settings: '/account/settings',
  Organization: '/account/organization',
  ManageMembers: '/account/manage-members',
  Plans: '/account/plans',
  Billing: '/account/billing',
};
